import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import Bill from './Bill';

const PrintBill = () => {
   const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({ contentRef });

  const billData = {
    customerName: 'John Doe',
    item: [
      { name: 'Burger', qty: 2, price: 150 },
      { name: 'Fries', qty: 1, price: 80 },
      { name: 'Soda', qty: 1, price: 50 },
    ],
    total: 430,
  };

  return (
    <div>
      <button onClick={handlePrint}>Print Bill</button>

      {/* This is the component that will be printed */}
      <div ref={contentRef}>
        <Bill {...billData} />
      </div>
    </div>
  );
};

export default PrintBill;
